/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Tag16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M14.386 7.623a2.083 2.083 0 010 2.954l-3.82 3.811a2.1 2.1 0 01-2.963 0l-5.42-5.406a2.081 2.081 0 01-.597-1.21l-.569-4.417A2.091 2.091 0 013.38 1.019l4.383.599c.453.061.874.27 1.197.592l5.427 5.413zM5.57 3.43c-.58-.58-1.53-.572-2.121.019-.591.59-.6 1.54-.019 2.12.58.582 1.53.573 2.121-.018.591-.59.6-1.54.019-2.12z"
        />
    </AccessibleSVG>
);

export default Tag16;
